import { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import { years_list, months_list } from "../../Shared/List"

const GeneratePayrolForm = (props) => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [yearOptions, setYearOptions] = useState([])
    const [monthOptions, setMonthOptions] = useState([])

    const [formData, setFormData] = useState({
        year: billing_date.year,
        month: billing_date.month,
        date: new Date().toISOString().slice(0, 10),
        remark: "",
        rate: 1.00
    })
    const {year, month, date, remark, rate} = formData

    const navigate = useNavigate()

    useEffect(() => {
        const getOptions = async () => {
            setIsLoading(true)
            try {
                const years = []
                const months = []
                years_list.map(year => (
                    years.push({
                        id: year.id,
                        key: year.key,
                        name: year.name
                    })
                ))

                months_list.map(month => (
                    months.push({
                        id: month.id,
                        key: month.key,
                        name: month.name
                    })
                ))
                setYearOptions(years)
                setMonthOptions(months)
                setIsLoading(false) 
            } catch (error) {
                setIsLoading(false)

                setYearOptions([])
                setMonthOptions([])
            }
        }
        
        getOptions()
    }, [])

    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()


        const payload = {year, month, remark, date, rate}
        generatePayroll(payload)
    }
    
    // generate payroll
    const generatePayroll = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/payrolls/generate/employee', payload)
            if (response.status === 200){
                toast.success(response.data?.detail)
                navigate('/payroll')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Generate Payroll Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectField
                                name="year"
                                label="Year"
                                value={parseInt(year)}
                                options={yearOptions}
                                onChange={onChange}
                                error={errors.year}
                            />
                        </div>
                        <div className="col-md-6">
                            <SelectField
                                name="month"
                                label="Month"
                                value={parseInt(month)}
                                options={monthOptions}
                                onChange={onChange}
                                error={errors.month}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                                max={new Intl.DateTimeFormat('en-CA').format(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0))}
                            />
                        </div>
                        <div className="col-md-3">
                            <NullableInput
                                name="rate"
                                type="numbar"
                                label="Rate (Optional)"
                                value={rate}
                                onChange={onChange}
                                error={errors.rate}
                            />
                        </div>
                        <div className="col-md-6">
                            <NullableInput
                                placeholder="Remark (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Generate Payroll" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default GeneratePayrolForm
